import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useHistory, useParams } from 'react-router-dom';

// componentes
import { Card, Col, Row } from 'react-bootstrap';
import Carregador from './../../Componentes/Carregador';
import PaginacaoComponente from './../../Componentes/Paginacao';
import Parametros from './Parametros';
import Registro from './Registro';
import ModalExcluir from './ModalExcluir';
import ModalCadastrar from './ModalCadastrar';


// componente
export default function Ip(){

    // estados
    const { id } = useParams();
    const history = useHistory();
    let [parametros, alterarParametros] = useState({
        pagina: 1,
        registrosPorPagina: 10,
        ativo: ['S'],
        texto: '',
    });
    let [totalRegistros, atualizarTotalRegistros] = useState(0);
    let [carregando, mostrarCarregando] = useState(false);
    let [consulta, alterarConsulta] = useState([]);
    const [excluir, alterarExcluir] = useState(null);
    const [cadastrar, alterarCadastrar] = useState(false);

    // inicializa
    useEffect(() => {
        consultarRegistros();
    }, [parametros]);

    // consulta registros
    async function consultarRegistros(){
        mostrarCarregando(true);

        try{

            // faz a requisição
            let { data } = await axios.get(`/usuariosIp/${id}`, { params: parametros });
            alterarConsulta(data.registros);
            atualizarTotalRegistros(parseInt(data.totalRegistros));

        }catch({response}){

        }finally{
            mostrarCarregando(false);
        }
    }

    // retorna
    return <>

        { excluir && 
            <ModalExcluir 
                id={excluir}
                fechou={() => {
                    alterarExcluir(null);
                }}
                excluido={() => {
                    consultarRegistros();
                }}
            />
        }
        
        { cadastrar && 
            <ModalCadastrar 
                idUsuario={id}
                fechou={() => {
                    alterarCadastrar(null);
                }}
                salvou={() => {
                    consultarRegistros();
                }}
            />
        }

        <Row>
            <Col>
                <Card className="painel-consulta border-0 shadow-sm" >
                    <div className="card-header ">
                        <h4 className="card-title font-weight-bolder">Endereços ip</h4>
                        {/* <p className="card-category">Here is a subtitle for this table</p> */}

                        <Parametros 
                            clicouCadastrar={() => {
                                alterarCadastrar(true);
                            }}
                            parametros={parametros} 
                            alterarParametros={alterarParametros} 
                        />
                    </div>
                    
                    <Card.Body>
                        
                        <table className="table table-hover tabela">
                            <thead>
                                <tr>
                                    <th>Ip</th>
                                    <th>Ações</th>
                                </tr>
                            </thead>
                            <tbody>
                                {consulta.map((registro, a) => 
                                    <Registro 
                                        key={a} 
                                        dados={registro}
                                        parametros={parametros}
                                        onClickTr={() => console.log('clicou TR')}
                                        clicouEditar={() => {
                                            // history.push(`/painel/grupos/alterar/${registro.id}`)
                                        }}
                                        clicouExcluir={() => {
                                            alterarExcluir(registro.id);
                                        }}
                                    />
                                )}
                            </tbody>
                        </table>
                        <PaginacaoComponente
                            pagina={parametros.pagina}
                            registrosPorPagina={parametros.registrosPorPagina}
                            totalRegistros={totalRegistros}
                            alterouPagina={(pagina) => {
                                alterarParametros({...parametros, pagina: pagina});
                            }}
                        />
                        {carregando && 
                            <Carregador className="rounded-bottom" />
                        }
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    </>
}